module.exports = __webpack_public_path__ + "img/deparentis.96caf6bc.png";